module.exports = __webpack_public_path__ + "html/subscription-messages_161549fb1f264612d022f8feca82b4d0.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/messages/subscription-messages.html
// module id = QM3b
// module chunks = 63